// extracted by mini-css-extract-plugin
export default {"headerNavItem":"MenuItem_headerNavItem__3b7PF","headerNavItemActive":"MenuItem_headerNavItemActive__ig0qp"};